export const ClicktracksTitleAccount = () => {
  return (
    <a
      href="/app/account"
      className="hidden aspect-square items-center justify-center rounded-full bg-zinc-200 dark:bg-zinc-900 sm:flex sm:h-24 sm:w-24"
    >
      <i className="bi-person hidden text-5xl opacity-50 sm:block sm:text-7xl" />
    </a>
  );
};
